module.exports = __webpack_public_path__ + "static/media/21ECLAC34.ee2c18b1.jpg";